export default "__VITE_ASSET__Dqc7nyOb__"